export const BASE_URL = "https://www.tasr.sk/volby2026";

// TEMPORARY: while these pages are still being prepared, show them only to
// TASR and a couple of named reviewers. Remove this whole gate once the
// section is ready for everyone.
const IP_PREFIXES_ALLOWED = ["195.46.72.", "195.46.89."];
const IPS_ALLOWED = ["46.34.251.173", "3.69.186.53"];

export function isAllowedIp(ip: string | null | undefined): boolean {
  if (!ip) return false;
  if (IPS_ALLOWED.includes(ip)) return true;
  return IP_PREFIXES_ALLOWED.some((prefix) => ip.startsWith(prefix));
}

export function formatNumber(n: number | undefined | null): string {
  if (n === undefined || n === null || isNaN(n as number)) return "0";
  return Number(n).toLocaleString("sk-SK");
}

export function formatPercent(n: number | undefined | null): string {
  if (n === undefined || n === null || isNaN(n as number)) return "0 %";
  return Number(n).toLocaleString("sk-SK", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " %";
}

export function normalizeSearchText(s: string): string {
  return s
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();
}

export type CandidateStatus = "elected" | "substitute" | "tie" | null;

export function statusLabel(status: CandidateStatus, final: boolean): string {
  if (status === "elected") return final ? "zvolený" : "vedie";
  if (status === "substitute") return "náhradník";
  if (status === "tie") return "rozhodne žreb";
  return "";
}
